/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get, isArray, isObject, omit } from 'lodash';

// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import StringsArrayInput from 'shared/ui/components/form-components/StringsArrayInput.vue';

const __vue_script__ = {
    name: 'WorkspaceCategory',

    components: { BaseInput, BaseSelect, StringsArrayInput },

    extends: BaseControl,

    props: {
        organization: {
            type: Object,
            default: () => null
        },

        value: {
            type: [String, Array, Object],
            default: null
        }
    },

    computed: {
        /** @return {boolean} */
        enabled() {
            return Boolean(this.organization);
        },

        /** @returns {object} */
        defaults() {
            return get(this, 'organization.workspace_defaults', {});
        },

        /** @returns {string} */
        fieldLabel() {
            return this.defaults.category_label;
        },

        /** @returns {boolean} */
        multi() {
            return this.defaults.category_multiselect;
        },

        /** @returns {string[]} */
        values() {
            return this.defaults.category_values || [];
        },

        /** @returns {object[]} */
        options() {
            if (isArray(this.values)) {
                return this.values.map(v => ({ label: v, value: v }));
            }

            return [];
        },

        innerValue: {
            /** @returns {object} */
            get() {
                if (!this.value) return undefined;

                if (isArray(this.value)) {
                    if (this.values.length) {
                        // change format for base-select component
                        return this.value.map(item => ({ label: item, value: item }));
                    } else {
                        // keep same format for strings-array-input component
                        return this.value;
                    }
                } else if (isObject(this.value)) {
                    return this.value;
                } else if (this.options.length) {
                    return this.options.find(o => o.value === this.value);
                }

                return this.value;
            },

            /**
             * @param {string|object} value
             */
            set(value) {
                if (isArray(value)) {
                    this.$emit('input', value.map(d => d.value ? d.value : d));
                } else if (isObject(value)) {
                    this.$emit('input', value.value);
                } else {
                    this.$emit('input', value);
                }
            }
        },

        /**
         * Pass-through listeners
         * @returns {object}
         */
        listeners() {
            // Here we skip the `input` listener, since we provide our own
            // and we don't want it to be overwritten.
            return omit(this.$listeners, 'input');
        },

        /**
         * Pass-through attributes
         * @returns {object}
         */
        attrs() {
            // Here we remove all the keys that we don't want `multiselect`
            // to inherit from this very component. All other options and attributes
            // are passed through. Basically an underscore.pluck, but since it has been
            // deprecated we are doing it manually.
            const attrs = omit(Object.assign(this.$options.propsData, this.$attrs), 'label', 'optionsLabel', 'value');

            attrs.label = this.$i18n.te(this.fieldLabel) ? this.$i18n.t(this.fieldLabel).toString() : this.fieldLabel;

            return attrs;
        },
    },
    methods: {
        /**
         * Utility method to make the template more readable
         *
         * @param {String} key the key to translate
         *
         * @return {String} the translated message
         */
        t(key) {
            return this.$i18n.t(`wizards.create_workspace.form.${key}`).toString();
        }
    },
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"workspace-category"},[(_vm.values.length)?_c('base-select',_vm._g(_vm._b({attrs:{"track-by":"value","multiple":_vm.multi,"options":_vm.options,"show-labels":false,"disabled":!_vm.enabled},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'base-select',_vm.attrs,false),_vm.listeners)):_vm._e(),(!_vm.values.length && _vm.multi)?_c('strings-array-input',_vm._b({attrs:{"emit-empty":true,"placeholder":_vm.t('category_values_placeholder')},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'strings-array-input',_vm.attrs,false)):_vm._e(),(!_vm.values.length && !_vm.multi)?_c('base-input',_vm._g(_vm._b({attrs:{"disabled":!_vm.enabled},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'base-input',_vm.attrs,false),_vm.listeners)):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "WorkspaceCategory.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__